import React from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'
import { View, StyleSheet } from '@react-pdf/renderer'

import TextWithCard from './TextWithCard'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    jussifyContent: 'space-between',
    width: '100%',
    gap: 20
  },

})

const DoubleTextWithCard = ({
  text, title, text2, title2, showSecondCard
}) => (
  <View style={styles.container}>
    <TextWithCard text={text} title={title} />
    {showSecondCard
      && <TextWithCard text={text2} title={title2} />}
  </View>
)

DoubleTextWithCard.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text2: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  showSecondCard: PropTypes.bool
}

DoubleTextWithCard.defaultProps = {
  showSecondCard: true
}

export default DoubleTextWithCard
